import * as Yup from 'yup';
import validatePasswordMinCharacterSets from '../../../helpers/passwordValidator';
import IRegisterForm from 'components/Customer/Interfaces/IRegisterForm';

export const getFormValidationRules = (config: IRegisterForm) => {
    const passwordConfig = config.passwordConfig;

    const conditionalCompanyField = () =>
        Yup.string()
            .transform((value, originalValue) => (originalValue === null ? '' : value))
            .nullable()
            .when('is_company', {
                is: 1,
                then: Yup.string().required(config.labels.requiredField),
                otherwise: Yup.string().nullable(),
            });

    return {
        firstname: Yup.string().nullable().required(config.labels.requiredField),
        lastname: Yup.string().nullable().required(config.labels.requiredField),
        email: Yup.string()
            .nullable()
            .email(config.emailConfig.emailMustBeValidErrorMessage)
            .required(config.labels.requiredField),
        password: Yup.string()
            .nullable()
            .required(config.labels.requiredField)
            .min(passwordConfig.minLength, passwordConfig.labels.minLengthLabel)
            .test('password-min-character-sets', passwordConfig.labels.minCharacterSetLabel, (value) =>
                value ? validatePasswordMinCharacterSets(value, passwordConfig.requiredCharacterClasses) : true,
            ),
        password_confirmation: Yup.string()
            .nullable()
            .required(config.labels.requiredField)
            .when('password', {
                is: (password: string | undefined) => (password ? password.length > 0 : false),
                then: Yup.string().nullable().required(config.labels.requiredField),
            })
            .oneOf([Yup.ref('password'), null], passwordConfig.labels.passwordMatchLabel),
        is_subscribed: Yup.number().nullable(),
        is_company: Yup.number().nullable(),
        company: conditionalCompanyField(),
        vat_id: conditionalCompanyField(),
        telephone: conditionalCompanyField(),
        street: conditionalCompanyField(),
        country_id: conditionalCompanyField(),
        region: conditionalCompanyField(),
        region_id: conditionalCompanyField(),
        city: conditionalCompanyField(),
        postcode: conditionalCompanyField(),
    };
};
